import { Box, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Repeat } from "lib/@components/repeat"
import { If, Else } from "lib/@components/switch"
import { LegislationScheduleRow } from "./legislation-schedule-row"

export function LegislationSchedulesTab() {
    const { schedules = [], customScheduleCount = 0 } = useBoundContext()
    const hasAny = schedules.length > 0 || customScheduleCount > 0

    return (
        <Box sx={{ px: 1, py: 1.5, maxHeight: 440, overflowY: "auto" }} data-cy="legislation-detail-schedules-tab">
            <If value={hasAny}>
                <Stack>
                    <Repeat list={schedules} item={<LegislationScheduleRow />} />
                    <If truthy={customScheduleCount > 0}>
                        <Typography
                            variant="body2"
                            sx={{ color: "text.secondary", px: 1.5, py: 1 }}
                            data-cy="legislation-detail-custom-schedule-count"
                        >
                            {customScheduleLabel()}
                        </Typography>
                    </If>
                </Stack>
                <Else>
                    <Typography variant="body2" sx={{ color: "text.secondary", px: 1, py: 1 }}>
                        No schedules reference this legislation.
                    </Typography>
                </Else>
            </If>
        </Box>
    )

    function customScheduleLabel() {
        return `Used by ${customScheduleCount} custom ${customScheduleCount === 1 ? "schedule" : "schedules"}`
    }
}
